<template>
    <li>
        <Component
            :is="LinkComponent"
            v-bind="LinkProp"
            :title="name"
            :class="[imageWrapperClassName, 'grid-image-with-name__image-wrapper']"
        >
            <ProgressiveImage
                :data="{ src: image, alt: name }"
                :class="[imageClassName, 'grid-image-with-name__image']"
            />
        </Component>
        <Component
            :is="LinkComponent"
            v-bind="LinkProp"
            :title="name"
            :class="[nameWrapperClassName, 'grid-image-with-name__name-wrapper']"
        >
            <template v-if="!subName.length">
                {{ name }}
            </template>
            <template v-else>
                <span class="base-text">
                    {{ subName }}
                </span>
                <span>
                    {{ name }}
                </span>
            </template>
        </Component>
    </li>
</template>

<script>
import ProgressiveImage from '~/components/common/Image/ProgressiveImage';

export default {
    name: 'ItemGridImageWithName',
    components: {
        ProgressiveImage,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        subName: {
            type: String,
            default: '',
        },
        relativePath: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        inside: {
            type: Boolean,
            default: false,
        },
        insideRedirect: {
            type: Boolean,
            default: false,
        },
        rootClass: {
            type: String,
            required: true,
        },
    },
    computed: {
        nameWrapperClassName() {
            if (!this.rootClass) {
                return null;
            }
            return `${this.rootClass}__name-wrapper`;
        },
        imageClassName() {
            if (!this.rootClass) {
                return null;
            }
            return `${this.rootClass}__image`;
        },
        imageWrapperClassName() {
            if (!this.rootClass) {
                return null;
            }
            return `${this.rootClass}__image-wrapper`;
        },
        LinkComponent() {
            return this.insideRedirect ? 'NuxtLink' : 'a';
        },
        LinkProp() {
            return this.insideRedirect ? { to: this.relativePath } : { href: this.url };
        },
    },
};
</script>

<style lang="scss">
    .grid-image-with-name {
        $self: &;

        &__item {
            max-width: 266px;

            &:hover {
                cursor: pointer;

                .grid-image-with-name__name-wrapper {
                    text-decoration: underline;
                }
            }
        }

        &__image-wrapper {
            max-width: 266px;
            min-height: 246px;
            max-height: 266px;

            &:hover .grid-image-with-name__image {
                transform : scale(0.95);
            }
        }

        &__image {
            max-width: 100%;
            max-height: 100%;
            transition: transform 0.2s ease-in;
        }

        &__name-wrapper {
            width: 100%;
            text-align: center;
            font: $font-weight-bold 16px/28px $goodHomeFontFamily;
            color: $color-slate100;
            text-decoration: none;
            padding-top: 18px;

            &:hover {
                text-decoration: underline;
                color: $color-slate100-dark;
                cursor: pointer;
            }
        }

        &__image-wrapper, &__name-wrapper {
            display: block;
        }
    }

    @media (max-width: $breakpoint-big-desktop) {
        .grid-image-with-name__image-wrapper {
            max-width: 213px;
            height: 213px;
        }
    }

    @media (max-width: $breakpoint-small-desktop) {
        .grid-image-with-name__image-wrapper {
            max-width: 226px;
            height: 226px;
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .grid-image-with-name__image-wrapper {
            max-width: 160px;
            height: 160px;
        }
    }

    .grid-image-with-name--inside {
        .grid-image-with-name {
            &__item {
                position: relative;
                line-height: 0;
            }

            &__item:hover {
                .grid-image-with-name__image {
                    transform: none;
                }

                .grid-image-with-name__name-wrapper {
                    text-decoration: none;
                    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 0%,rgba(0,0,0,0.7) 100%);
                }
            }

            &__name-wrapper {
                width: calc(100% - 20px);
                position: absolute;
                bottom: 0;
                left: 0;
                padding: 20px;
                margin: 0 10px 10px 10px;
                color: $color-castoWhite;
                text-align: left;
                background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 100%);
                text-transform: none;
                font: $font-weight-bold 14px/16px $goodHomeFontFamily;

                span {
                    display: inline-block;
                    width: 100%;

                    + span {
                        margin-top: 6px;
                        font-weight: $font-weight-light;
                        line-height: 18px;
                        font-size: 16px;
                    }
                }

                .base-text {
                    font-weight: $font-weight-bold;
                    font-size: 20px;
                }
            }
        }
    }

    @media (min-width: $breakpoint-smart-phones) {
        .grid-image-with-name {
            &__image-wrapper {
                min-height: auto;
            }

            &__name-wrapper {
                font: $font-weight-bold 16px/18px $goodHomeFontFamily;
            }
        }
    }

    @media (min-width: $breakpoint-phones) {
        .grid-image-with-name__image-wrapper {
            min-height: 235px;
        }
    }

    @media (min-width: $breakpoint-tablet) {
        .grid-image-with-name__image-wrapper {
            min-height: 219px;
        }
    }

</style>
